"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleRecordUnknown = void 0;
const market_rule_record_field_1 = require("./market-rule-record-field");
class MarketRuleRecordUnknown extends market_rule_record_field_1.MarketRuleRecordField {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        this.getValue = () => void 0;
    }
}
exports.MarketRuleRecordUnknown = MarketRuleRecordUnknown;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtcmVjb3JkLXVua25vd24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29udGVudC9oaXN0b3JpY2FsLXByaWNpbmcvdGltZS1zZXJpZXMvc2VydmljZXMvcnVsZS1lbmdpbmUtc2VydmljZS9jbGFzc2VzL21hcmtldC1ydWxlLXJlY29yZC11bmtub3duLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHlFQUFtRTtBQUVuRSxNQUFhLHVCQUF3QixTQUFRLGdEQUFxQjtJQUM5RDs7O09BR0c7SUFDSCxZQUFtQixHQUFzQztRQUNyRCxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7UUFHUixhQUFRLEdBQUcsR0FBRyxFQUFFLENBQUMsS0FBSyxDQUFDLENBQUM7SUFGL0IsQ0FBQztDQUdKO0FBVkQsMERBVUMifQ==